import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import BottomNav from '../BottomNav';
import FavoriteButton from './FavoriteButton';
import theme from '../theme';

function BadgeVerificatoWhite({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={{ display: 'inline-block', verticalAlign: 'middle', marginLeft: 5, flexShrink: 0 }}>
      <path d="M8 1L2 3.5V8c0 3.3 2.5 5.8 6 7 3.5-1.2 6-3.7 6-7V3.5L8 1z" fill="rgba(255,255,255,0.95)"/>
      <path d="M5.5 8l2 2 3-3" stroke={theme.colors.primary} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

function StatCell({ num, label, sub }) {
  return (
    <div style={{ background: 'rgba(255,255,255,0.13)', borderRadius: theme.radius.md, padding: '8px 6px', textAlign: 'center', flex: 1 }}>
      <div style={{ fontSize: theme.font.size.xxl, fontWeight: 600, color: theme.colors.white, lineHeight: 1 }}>{num}</div>
      {sub && <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.7)', marginTop: 1 }}>{sub}</div>}
      <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.8)', marginTop: 2, lineHeight: 1.3 }}>{label}</div>
    </div>
  );
}

function StarCell({ avg, count, label }) {
  return (
    <div style={{ background: 'rgba(255,255,255,0.13)', borderRadius: theme.radius.md, padding: '8px 6px', textAlign: 'center', flex: 1 }}>
      {avg
        ? <>
            <div style={{ fontSize: theme.font.size.md, color: theme.colors.starGold, lineHeight: 1 }}>★ {avg}</div>
            <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.7)', marginTop: 1 }}>({count} rec.)</div>
          </>
        : <div style={{ fontSize: theme.font.size.sm, color: 'rgba(255,255,255,0.5)', lineHeight: 1.4 }}>—</div>
      }
      <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.8)', marginTop: 2, lineHeight: 1.3 }}>{label}</div>
    </div>
  );
}

function ReviewCard({ review, renderStars, reviewerName }) {
  const [lightbox, setLightbox] = useState(null);
  const [expanded, setExpanded] = useState(false);

  const formatDate = (dateStr) => new Date(dateStr).toLocaleDateString('it-IT', {
    day: '2-digit', month: '2-digit', year: 'numeric'
  });

  const photos = review.photos || [];
  const comment = review.comment || '';
  const isLong = comment.length > 100;

  const initials = (name) => name
    ? name.split(' ').map(p => p[0]).slice(0, 2).join('').toUpperCase()
    : '?';

  return (
    <div style={{
      border: '1px solid #e8e8e8',
      borderRadius: theme.radius.lg,
      padding: '12px 14px',
      marginBottom: 10,
      background: theme.colors.white
    }}>

      <div style={{ display: 'flex', alignItems: 'center', gap: theme.spacing.sm, marginBottom: 8 }}>

        <div style={{
          width: 36, height: 36, borderRadius: theme.radius.circle,
          background: theme.colors.primaryLight, display: 'flex', alignItems: 'center',
          justifyContent: 'center', fontSize: theme.font.size.sm, fontWeight: 600,
          color: theme.colors.primary, flexShrink: 0
        }}>
          {initials(reviewerName || review.reviewer_email)}
        </div>

        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: theme.font.size.base, fontWeight: 600, color: '#222', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {reviewerName || review.reviewer_email}
          </div>
          <div style={{ fontSize: theme.font.size.xs, color: '#aaa' }}>{formatDate(review.created_at)}</div>
        </div>

        <div style={{ display: 'flex', gap: 1, flexShrink: 0 }}>
          {renderStars(review.stars)}
        </div>
      </div>

      {comment && (
        <div>
          <p style={{
            margin: '0 0 4px', fontSize: theme.font.size.base, color: '#444', lineHeight: 1.5,
            display: '-webkit-box', WebkitLineClamp: expanded ? 'unset' : 2,
            WebkitBoxOrient: 'vertical', overflow: 'hidden'
          }}>
            "{comment}"
          </p>
          {isLong && (
            <button
              onClick={() => setExpanded(e => !e)}
              style={{
                background: 'none', border: 'none', padding: 0,
                fontSize: theme.font.size.sm, color: theme.colors.primary, cursor: 'pointer'
              }}
            >
              {expanded ? 'Mostra meno' : 'Mostra tutto'}
            </button>
          )}
        </div>
      )}

      {photos.length > 0 && (
        <div style={{ display: 'flex', gap: 6, marginTop: 10, overflowX: 'auto' }}>
          {photos.map((url, index) => (
            <div
              key={index}
              onClick={() => setLightbox(index)}
              style={{
                width: 56, height: 56, borderRadius: theme.radius.sm, overflow: 'hidden',
                flexShrink: 0, cursor: 'pointer'
              }}
            >
              <img src={url} alt={`foto ${index + 1}`}
                style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
          ))}
        </div>
      )}

      {lightbox !== null && (
        <div onClick={() => setLightbox(null)} style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(0,0,0,0.9)', zIndex: 1000,
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <button onClick={e => { e.stopPropagation(); setLightbox(l => l > 0 ? l - 1 : photos.length - 1); }}
            style={{ position: 'absolute', left: 16, background: 'rgba(255,255,255,0.2)', border: 'none', color: theme.colors.white, fontSize: 28, cursor: 'pointer', borderRadius: theme.radius.circle, width: 44, height: 44 }}>‹</button>
          <img src={photos[lightbox]} alt="foto"
            style={{ maxWidth: '90%', maxHeight: '80vh', objectFit: 'contain', borderRadius: theme.radius.sm }} />
          <button onClick={e => { e.stopPropagation(); setLightbox(l => l < photos.length - 1 ? l + 1 : 0); }}
            style={{ position: 'absolute', right: 16, background: 'rgba(255,255,255,0.2)', border: 'none', color: theme.colors.white, fontSize: 28, cursor: 'pointer', borderRadius: theme.radius.circle, width: 44, height: 44 }}>›</button>
          <button onClick={() => setLightbox(null)}
            style={{ position: 'absolute', top: 16, right: 16, background: 'rgba(255,255,255,0.2)', border: 'none', color: theme.colors.white, fontSize: 20, cursor: 'pointer', borderRadius: theme.radius.circle, width: 36, height: 36 }}>✕</button>
          <div style={{ position: 'absolute', bottom: 20, color: theme.colors.white, fontSize: theme.font.size.base }}>
            {lightbox + 1} / {photos.length}
          </div>
        </div>
      )}
    </div>
  );
}

function PublicProfile({ session }) {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const [jobs, setJobs] = useState([]);
  const [onlineJobs, setOnlineJobs] = useState([]);
  const [reviewsAsWorker, setReviewsAsWorker] = useState([]);
  const [reviewsAsOwner, setReviewsAsOwner] = useState([]);
  const [reviewerNames, setReviewerNames] = useState({});
  const [onlineJobsCount, setOnlineJobsCount] = useState(0);
  const [completedCommissioned, setCompletedCommissioned] = useState(0);
  const [completedDone, setCompletedDone] = useState(0);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('info');
  const [favoriteIds, setFavoriteIds] = useState(new Set());
  const [isOwnProfile, setIsOwnProfile] = useState(false);

  useEffect(() => { fetchProfile(); fetchFavorites(); }, [userId]);

  const fetchFavorites = async () => {
    const { data } = await supabase
      .from('favorites')
      .select('job_id')
      .eq('user_id', session.user.id);
    if (data) setFavoriteIds(new Set(data.map(f => f.job_id)));
  };

  const toggleFavorite = async (jobId) => {
    const isFav = favoriteIds.has(jobId);
    setFavoriteIds(prev => {
      const next = new Set(prev);
      if (isFav) next.delete(jobId); else next.add(jobId);
      return next;
    });
    if (isFav) {
      await supabase.from('favorites').delete().eq('user_id', session.user.id).eq('job_id', jobId);
    } else {
      await supabase.from('favorites').insert({ user_id: session.user.id, job_id: jobId });
    }
  };

  const fetchProfile = async () => {
    setLoading(true);

    const { data: profileData } = await supabase
      .from('profiles').select('*').eq('id', userId).single();
    if (!profileData) { navigate('/'); return; }
    setProfile(profileData);
    setIsOwnProfile(profileData.id === session.user.id);

    const { data: jobsData } = await supabase
      .from('jobs')
      .select('*')
      .eq('author', profileData.full_name)
      .order('created_at', { ascending: false });
    setJobs(jobsData || []);

    if (jobsData && jobsData.length > 0) {
      const jobIds = jobsData.map(j => j.id);

      const { data: acceptedApps } = await supabase
        .from('applications')
        .select('job_id')
        .in('job_id', jobIds)
        .eq('status', 'accettata');

      const acceptedCountByJob = {};
      (acceptedApps || []).forEach(app => {
        acceptedCountByJob[app.job_id] = (acceptedCountByJob[app.job_id] || 0) + 1;
      });

      const openJobs = jobsData.filter(j => {
        const needed = j.people_needed || 1;
        const accepted = acceptedCountByJob[j.id] || 0;
        return accepted < needed;
      });
      setOnlineJobs(openJobs);
      setOnlineJobsCount(openJobs.length);

      const { data: paidApps } = await supabase
        .from('applications')
        .select('id')
        .in('job_id', jobIds)
        .not('amount_paid', 'is', null);
      setCompletedCommissioned((paidApps || []).length);
    }

    const { data: paidDoneApps } = await supabase
      .from('applications')
      .select('id')
      .eq('applicant_id', userId)
      .not('amount_paid', 'is', null);
    setCompletedDone((paidDoneApps || []).length);

    const { data: reviewsData } = await supabase
      .from('reviews').select('*')
      .eq('reviewed_email', profileData.full_name)
      .order('created_at', { ascending: false });

    if (reviewsData) {
      setReviewsAsWorker(reviewsData.filter(r => r.role === 'lavoratore'));
      setReviewsAsOwner(reviewsData.filter(r => r.role === 'committente'));

      const emails = [...new Set(reviewsData.map(r => r.reviewer_email))];
      const nameMap = {};
      for (const email of emails) {
        if (email.includes('@')) {
          const { data: rpcResult } = await supabase.rpc('get_profile_by_email', { user_email: email });
          if (rpcResult && rpcResult.length > 0) {
            nameMap[email] = rpcResult[0].full_name;
          } else {
            nameMap[email] = email.split('@')[0];
          }
        } else {
          nameMap[email] = email;
        }
      }
      setReviewerNames(nameMap);
    }

    setLoading(false);
  };

  const avgStars = (reviews) => {
    if (!reviews.length) return null;
    return (reviews.reduce((sum, r) => sum + r.stars, 0) / reviews.length).toFixed(1);
  };

  const renderStars = (stars) => [1, 2, 3, 4, 5].map(s => (
    <span key={s} style={{ color: s <= stars ? theme.colors.starGold : '#ddd', fontSize: 14 }}>★</span>
  ));

  if (loading) return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: theme.font.family, color: theme.colors.primary }}>
      Caricamento...
    </div>
  );

  return (
    <div style={{ maxWidth: theme.layout.maxWidth, margin: '0 auto', fontFamily: theme.font.family }}>

      {/* Header verde */}
      <div style={{ background: theme.colors.primary, padding: '16px 20px', display: 'flex', alignItems: 'center', gap: theme.spacing.md }}>
        <button onClick={() => navigate(-1)} style={{ background: 'none', border: 'none', color: theme.colors.white, fontSize: 22, cursor: 'pointer', padding: 0 }}>←</button>
        <h2 style={{ margin: 0, color: theme.colors.white, fontSize: theme.font.size.xxl }}>Profilo</h2>
      </div>

      <div style={{ background: theme.colors.primary, padding: '0 20px 18px', color: theme.colors.white, textAlign: 'center' }}>
        <div style={{
          width: 72, height: 72, borderRadius: theme.radius.circle,
          background: 'rgba(255,255,255,0.25)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontWeight: 700, fontSize: theme.font.size.xxl, color: theme.colors.white,
          margin: '0 auto 10px', overflow: 'hidden',
          border: '2px solid rgba(255,255,255,0.5)'
        }}>
          {profile?.avatar_url
            ? <img src={profile.avatar_url} alt="avatar" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            : profile?.full_name?.[0]?.toUpperCase() || '?'
          }
        </div>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 2 }}>
          <span style={{ fontSize: theme.font.size.xl, fontWeight: 700 }}>{profile?.full_name}</span>
          {profile?.identity_status === 'verificato' && <BadgeVerificatoWhite size={18} />}
        </div>
        {profile?.city && <div style={{ fontSize: theme.font.size.sm, opacity: 0.8, marginBottom: 10 }}>📍 {profile.city}</div>}

        <div style={{ borderTop: '0.5px solid rgba(255,255,255,0.2)', margin: '10px 0' }} />

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6, marginBottom: 6 }}>
          <StatCell num={completedDone} label="Lavori svolti" sub="💰 pagati" />
          <StarCell avg={avgStars(reviewsAsWorker)} count={reviewsAsWorker.length} label="⭐ come lavoratore" />
          <StatCell num={completedCommissioned} label="Lavori commissionati" sub="💰 pagati" />
          <StarCell avg={avgStars(reviewsAsOwner)} count={reviewsAsOwner.length} label="⭐ come committente" />
        </div>

        <div style={{ background: 'rgba(255,255,255,0.13)', borderRadius: theme.radius.md, padding: '8px 6px', textAlign: 'center' }}>
          <div style={{ fontSize: theme.font.size.xxl, fontWeight: 600, color: theme.colors.white, lineHeight: 1 }}>{onlineJobsCount}</div>
          <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.8)', marginTop: 2 }}>📋 Annunci online (candidature aperte)</div>
        </div>
      </div>

      <div style={{ padding: theme.spacing.xl, paddingBottom: 80 }}>

        {/* Tab bar */}
        <div style={{ display: 'flex', borderBottom: '1px solid #eee', marginBottom: theme.spacing.xl, overflowX: 'auto' }}>
          {['info', 'recensioni', 'annunci'].map(tab => (
            <button key={tab} onClick={() => setActiveTab(tab)} style={{
              flexShrink: 0, padding: '10px 16px', border: 'none', background: 'none',
              borderBottom: activeTab === tab ? `2px solid ${theme.colors.primary}` : '2px solid transparent',
              color: activeTab === tab ? theme.colors.primary : theme.colors.textMuted,
              cursor: 'pointer', fontSize: theme.font.size.md, fontWeight: activeTab === tab ? 600 : 400
            }}>
              {tab === 'info' ? 'Info' : tab === 'recensioni' ? 'Recensioni' : 'Annunci'}
            </button>
          ))}
        </div>

        {/* Tab Info */}
        {activeTab === 'info' && (
          <div style={{ border: `1px solid ${theme.colors.border}`, borderRadius: theme.radius.lg, padding: theme.spacing.xl }}>
            {profile?.bio ? (
              <div style={{ marginBottom: theme.spacing.lg }}>
                <div style={{ fontSize: theme.font.size.sm, color: theme.colors.textMuted, marginBottom: 4 }}>📝 Bio</div>
                <p style={{ margin: 0, fontSize: theme.font.size.lg, color: theme.colors.textPrimary, lineHeight: 1.6 }}>{profile.bio}</p>
              </div>
            ) : (
              <p style={{ color: theme.colors.textMuted, fontSize: theme.font.size.md, textAlign: 'center' }}>Nessuna bio inserita.</p>
            )}
            {profile?.city && (
              <div>
                <div style={{ fontSize: theme.font.size.sm, color: theme.colors.textMuted, marginBottom: 4 }}>📍 Città</div>
                <p style={{ margin: 0, fontSize: theme.font.size.lg, color: theme.colors.textPrimary }}>{profile.city}</p>
              </div>
            )}
          </div>
        )}

        {/* Tab Recensioni */}
        {activeTab === 'recensioni' && (
          <div>
            <div style={{ marginBottom: 28 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
                <span style={{ fontSize: theme.font.size.lg }}>👷</span>
                <span style={{ fontWeight: 700, fontSize: theme.font.size.lg }}>Come lavoratore</span>
                {avgStars(reviewsAsWorker) && (
                  <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <span style={{ color: theme.colors.starGold }}>★</span>
                    <span style={{ fontWeight: 700 }}>{avgStars(reviewsAsWorker)}</span>
                    <span style={{ color: theme.colors.textMuted, fontSize: theme.font.size.base }}>({reviewsAsWorker.length})</span>
                  </span>
                )}
              </div>
              {reviewsAsWorker.length === 0
                ? <p style={{ color: theme.colors.textMuted, fontSize: theme.font.size.md, textAlign: 'center', padding: '16px 0' }}>Nessuna recensione ancora.</p>
                : reviewsAsWorker.map(r => (
                    <ReviewCard
                      key={r.id}
                      review={r}
                      renderStars={renderStars}
                      reviewerName={reviewerNames[r.reviewer_email] || r.reviewer_email}
                    />
                  ))
              }
            </div>

            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
                <span style={{ fontSize: theme.font.size.lg }}>💼</span>
                <span style={{ fontWeight: 700, fontSize: theme.font.size.lg }}>Come committente</span>
                {avgStars(reviewsAsOwner) && (
                  <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <span style={{ color: theme.colors.starGold }}>★</span>
                    <span style={{ fontWeight: 700 }}>{avgStars(reviewsAsOwner)}</span>
                    <span style={{ color: theme.colors.textMuted, fontSize: theme.font.size.base }}>({reviewsAsOwner.length})</span>
                  </span>
                )}
              </div>
              {reviewsAsOwner.length === 0
                ? <p style={{ color: theme.colors.textMuted, fontSize: theme.font.size.md, textAlign: 'center', padding: '16px 0' }}>Nessuna recensione ancora.</p>
                : reviewsAsOwner.map(r => (
                    <ReviewCard
                      key={r.id}
                      review={r}
                      renderStars={renderStars}
                      reviewerName={reviewerNames[r.reviewer_email] || r.reviewer_email}
                    />
                  ))
              }
            </div>
          </div>
        )}

        {/* Tab Annunci */}
        {activeTab === 'annunci' && (
          <div>
            {onlineJobs.length === 0
              ? <p style={{ color: theme.colors.textMuted, fontSize: theme.font.size.md, textAlign: 'center', padding: '16px 0' }}>Nessun annuncio online al momento.</p>
              : onlineJobs.map(job => (
                <div key={job.id} onClick={() => navigate(`/job/${job.id}`)} style={{
                  border: `1px solid ${theme.colors.border}`, borderRadius: theme.radius.lg, padding: theme.spacing.lg, marginBottom: theme.spacing.md, cursor: 'pointer', position: 'relative'
                }}>
                  {!isOwnProfile && (
                    <div style={{ position: 'absolute', top: 10, right: 10, zIndex: 2 }}>
                      <FavoriteButton isFavorite={favoriteIds.has(job.id)} onToggle={() => toggleFavorite(job.id)} />
                    </div>
                  )}
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6, paddingRight: !isOwnProfile ? 40 : 0 }}>
                    <span style={{ fontWeight: 600, fontSize: theme.font.size.lg }}>{job.title}</span>
                    <span style={{ color: theme.colors.primary, fontWeight: 600 }}>{job.price}</span>
                  </div>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    <span style={{ background: theme.colors.primaryLight, color: theme.colors.primary, padding: '2px 8px', borderRadius: theme.radius.md, fontSize: theme.font.size.sm }}>{job.category}</span>
                    {job.city && <span style={{ fontSize: theme.font.size.sm, color: theme.colors.textMuted }}>📍 {job.city}</span>}
                  </div>
                </div>
              ))
            }
          </div>
        )}
      </div>

      <BottomNav />
    </div>
  );
}

export default PublicProfile;